import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const addCountry = createAsyncThunk('addCountry', async (data) => {

    try {
        const res = await axios({

            method: 'POST',
            url: process.env.REACT_APP_API_URL + 'country',
            data: {
                "country": data?.values?.countryName,
                "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})